export default __webpack_public_path__ + "static/media/surge.33021678.webp";